<template>
  <div>
    <button class="copy-url-button" @click="copyUrl">
      <svg-icon type="mdi" :path="path"></svg-icon>
    </button>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiContentCopy } from '@mdi/js'

export default {
  name: 'CopyUrlButton',
  components: {
    SvgIcon
  },
  data: function () {
    return {
      path: mdiContentCopy
    }
  },
  methods: {
    copyUrl () {
      const url = window.location.href
      let toastOptions = {
        position: 'top-center',
        duration: 5000,
        className: 'toast'
      }
      this.$copyText(url)
        .then(() => {
          this.$toasted.success('URLをクリップボードにコピーしました', toastOptions)
        })
        .catch(() => {
          this.$toasted.error('URLのコピーに失敗しました', toastOptions)
        })
    }
  }
}
</script>

<style scoped>
.copy-url-button {
  cursor: pointer;
  margin: 3px;
  height: 32px;
  color: #000000;
  background-color:#FFFFFF;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  border: 929593;
  border-width: 1px;
  border-radius: 3px 3px 3px 3px;
}
.copy-url-button a:visited {
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/quest_modal/CopyUrlButton.vue